var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",class:{'banner-active': _vm.isActive},attrs:{"id":"banner"}},[_c('div',{staticClass:"alert",class:("alert-" + (_vm.store.banner.type))},[_vm._v("\n    "+_vm._s(_vm.store.banner.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }